import React from 'react'
import './card-title.css'

export default (props) => {
    return(
        <div className="card-screen-title-container">
            <p className="card-screen-title">{props.title}</p>
            <hr></hr>
        </div>
    )
}